//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import PchPurchaseInvoiceCreate from '@/views/Purchase/PchPurchaseInvoice/create'
import PchPurchaseInvoiceList from '@/views/Purchase/PchPurchaseInvoice/list'
import PchPurchaseInvoiceUpdate from '@/views/Purchase/PchPurchaseInvoice/update'

//
import {
    /*PurchaseInvoiceCreate,*/
    PurchaseInvoiceDetail,
    PurchaseInvoiceList,
} from '@/views/treasury/purchase-invoice'

//
import TaxDocumentListPendingView from '@/views/Purchase/PchTaxDocument/PchTaxDocumentPending'
import PurchaseTaxDocumentDetailView from '@/views/Purchase/PchTaxDocument/detail'

//
export default {
    path: 'purchase_invoice',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'pch-purchase-invoice-list',
            component: PchPurchaseInvoiceList,
        },
        {
            path: 'create',
            name: 'pch-purchase-invoice-create',
            component: PchPurchaseInvoiceCreate,
            meta: {
                title: 'Crear factura de compra',
            },
        },
        {
            path: ':id',
            name: 'purchase-invoice-detail',
            component: PchPurchaseInvoiceUpdate,
            meta: {
                title: 'Detalle de factura de compra',
            },
        },
    ],
    meta: {
        title: 'Facturas de compra',
    },
}

//
export const PurchaseInvoicePaidRoutes = {
    path: 'purchase_invoice_paid',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'purchase-tax-document-pending',
            component: TaxDocumentListPendingView,
        },
        {
            path: ':id',
            name: 'purchase-tax-document-detail',
            component: PurchaseTaxDocumentDetailView,
            meta: {
                title: 'Detalle de documento por pagar',
            },
        },
    ],
    meta: {
        title: 'Documentos por pagar',
    },
}

//
export const RegistryInvoiceRoutes = {
    path: 'register_invoice',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'register-invoice-list',
            component: PchPurchaseInvoiceCreate,
        },
    ],
    meta: {
        title: 'Ingreso de facturas',
        group: 'Tesorería',
    },
}
